<template>
    <tile class="business-index" link="business-index" >
        <tile-title slot="tileHeader" icon="bar-chart">Бизнес-коэффициенты</tile-title>

        <div slot="tileContent" class="business-index__content">
            <app-transition
                :showLeftIf="contentType === 'table'"
                :showRightIf="contentType === 'chart'"
            >
                <business-index-table 
                    v-if="data && years.length" 
                    :years="years.slice(-3)" 
                    :targetObj="data"
                    slot="left" 
                />
                <buisness-index-chart
                    v-if="data && years.length"  
                    :years="years" 
                    :targetObj="data" 
                    slot="right" 
                />
            </app-transition>
            <business-index-modal
                v-show="isModal"
                @close="closeModal"
                :years="years"
                :targetObj="data"
                :title="title"
                :printStyle="printStyle"
                :htmlForPrint="htmlContent"
                ref="modal" 
            />
        </div>

        <div slot="tileFooter" class="business-index__footer">
            <div class="btn-container">
                <tile-button @click.native="openModal">Все показатели</tile-button>
                <app-switcher
                    :leftClickHandler="toggle"
                    :rightClickHandler="toggle"
                >
                    <span slot="leftValue"><i class="uk-icon-bars"></i> Таблица</span>
                    <span slot="rightValue"><i class="uk-icon-area-chart"></i> График</span>
                </app-switcher>
            </div>
            <tile-print-pdf
                :html="htmlContent"
                :printStyle="printStyle"
                :title="title"
                filename="businessIndex" 
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import appTransition from '@/components/ui/appTransition/appTransition.vue'
import tileButton from '@/components/ui/tileButton/tileButton.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import businessIndexTable from '@/components/card/businessIndex/businessIndexTable.vue'
import buisnessIndexChart from '@/components/card/businessIndex/buisnessIndexChart.vue'
import businessIndexModal from '@/components/card/businessIndex/businessIndexModal.vue'

import { cutTable } from '@/helpers.ts'

export default {
    components: {
        tile,
        tileTitle,
        appSwitcher,
        appTransition,
        tileButton,
        tilePrintPdf,
        businessIndexTable,
        buisnessIndexChart,
        businessIndexModal
    },
    computed: {
        inn() { return this.$store.state.card?.company?.inn },
        type() { return this.$store.state.card?.company?.type },
        data() { return this.$store.state.card?.businessIndex?.data },
        years() { return this.$store.getters['card/businessIndex/years'] },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_short },
        title() { return `Бизнес-коэффициенты | ${this.companyName}` }
    },
    data() {
        return {
            contentType: 'table',
            isModal: false,
            htmlContent: '',
            printYearsLimit: 15,
            printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
                .index-table { border-collapse: collapse; margin: 0 auto; }
                .index-table tr td, .index-table tr th { font-size: 14px; padding: 8px 4px; border: 1px solid #000; text-align: center; }
                .index-table tr td.cursor-help.fw-bold, .index-table tr th { background: #ddddde; font-weight: 700; }
                .index-table tr th:first-child, .index-table tr td.cursor-help.fw-bold { text-align: left; }
                .index-table tr td.green { color: #03ae4b; }
                .index-table tr td.red { color: #df1500; }
                .print-main-title { font-family: "Times New Roman", Times, serif; font-weight: 700; }
            `
        }
    },
    methods: {
        toggle() {
            this.contentType = this.contentType === 'table' ? 'chart' : 'table'
        },
        closeModal() { this.isModal = false },
        openModal() { this.isModal = true }
    },
    mounted() {
        if(!this.inn || this.type === 'ip') {
            $('#business-index-tile').hide()
            $('#tiles').trigger('resize')
        } else {
            this.$store.dispatch('card/businessIndex/getData', this.inn)
                .finally(() => {
                    $('#tiles').trigger('resize')
                    if(this.years?.length > this.printYearsLimit) {
                        this.$nextTick(() => {
                            const srcTable = this.$refs.modal?.$refs?.htmlContent.firstElementChild
                            this.htmlContent = cutTable(srcTable, 2, this.years.length - this.printYearsLimit, 'index-table' )
                            
                        })
                    } else {
                        this.$nextTick(() => {
                            this.htmlContent = this.$refs.modal?.$refs?.htmlContent?.outerHTML || ''
                        })
                    }
                })
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.business-index
    &__footer
        @include flex-between
        .btn-container
            display: flex
            gap: 5px
</style>